import "./peopleTable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import {
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  CircularProgress,
} from "@mui/material";
import { Delete, Edit, Add } from "@mui/icons-material";

const PeopleTable = () => {
  //global userId and adminType to controller access
  const userId = useSelector((state) => state.user.userId);
  const adminType = useSelector((state) => state.user.adminType);

  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();

  // States
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true); // Loading state
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState(null);

  // Fetch all users
  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true); // Set loading state to true before fetching
      try {
        const res = await axios.get(
          BASE_URL + `/api/people/findAllPeople/${userId}`
        );
        setData(res.data);
      } catch (err) {
        console.error(err);
      }
      setLoading(false); // Set loading state to false after data is fetched
    };
    fetchUsers();
  }, [BASE_URL]);

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(
        BASE_URL + `/api/people/deletePeople/${id}`
      );
      if (response.status === 200) {
        setData(data.filter((item) => item._id !== id));
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleUpdate = (peopleData) => {
    navigate("/people/newPeople", { state: { people: peopleData } });
  };

  const userListColumns = [
    { field: "_id", headerName: "ID", width: 70 },
    {
      field: "fullName",
      headerName: "Full Name",
      width: 150,
    },
    {
      field: "fatherName",
      headerName: "Father Name",
      width: 150,
    },
    {
      field: "motherName",
      headerName: "Mother Name",
      width: 150,
    },
    {
      field: "grandFatherName",
      headerName: "Grand Fa. Name",
      width: 150,
    },
    {
      field: "gender",
      headerName: "Gender",
      width: 100,
    },
    {
      field: "dob",
      headerName: "DOB",
      width: 130,
    },
    {
      field: "status",
      headerName: "Status",
      width: 100,
    },
  ];

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <IconButton color="primary" aria-label="add">
              <Link to="/people/newPeople" style={{ textDecoration: "none" }}>
                <Add />
              </Link>
            </IconButton>
            <IconButton
              onClick={() => handleUpdate(params.row)}
              color="primary"
              aria-label="update"
            >
              <Edit />
            </IconButton>
            <IconButton
              onClick={() => {
                setSelectedUsers(params.row);
                setOpenDialog(true);
              }}
              color="error"
              aria-label="delete"
            >
              <Delete />
            </IconButton>
          </div>
        );
      },
    },
  ];

  const handleDialogClose = () => {
    setOpenDialog(false);
    setSelectedUsers(null);
  };

  const handleConfirmDelete = async () => {
    if (selectedUsers) {
      await handleDelete(selectedUsers._id);
      setOpenDialog(false);
    }
  };

  return (
    <div className="datatable">
      <div className="datatableTitle">
        <Typography variant="h5" gutterBottom>
          List Of Population
        </Typography>
        <Link to="/people/newPeople">
          <Button variant="contained" color="primary">
            Add People
          </Button>
        </Link>
      </div>
      <Grid container justifyContent="center">
        {loading ? ( // Show loading indicator while fetching
          <CircularProgress size={50} />
        ) : (
          <DataGrid
            className="datagrid"
            rows={data}
            columns={userListColumns.concat(actionColumn)}
            pageSize={5}
            rowsPerPageOptions={[5]}
            checkboxSelection
            getRowId={(row) => row._id}
          />
        )}
      </Grid>

      <Dialog open={openDialog} onClose={handleDialogClose}>
        <DialogTitle>Delete Confirmation</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to delete this People?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default PeopleTable;
